import { Component, OnInit, Input } from '@angular/core';
import { AerovaleDetalle } from '@shared/models/despacho/AerovaleDetalle';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { AerovalesService } from '../aerovales.service';
import { Observacion } from '@shared/models/despacho/Observacion';
import { ModalOkComponent } from '@shared/generic-modals/modal-ok.component';
import { UsuarioService } from '@account/usuario.service';
import { Usuario } from '@shared/models/despacho/Usuario';
import { ErrorModel } from '@shared/models/ErrorModel';
import { MessageService } from '@shell/message.service';
import { AerovaleAnulacionReemplazoDTO } from '@shared/models/despacho/AerovaleAnulacionReemplazoDTO';
import { CargaArchivo } from '@shared/models/cliente/CargaArchivo';
import { TipoBlobStorage } from '@shared/enums/TipoBlobStorage';
import { BlobUploadCommonResponse } from '@azure/storage-blob';
import { StockService } from '@stock/stock.service';
import { AzureBlobUploadService } from '@shared/azure-blob-upload.service';
import { Sas } from '@shared/models/padrones/Sas';
import { isEmptyValue } from '@shared/compat-tools';

@Component({
  selector: 'app-modal-anulacion-aerovale',
  templateUrl: './modal-anulacion-aerovale.component.html',
  styleUrls: ['./modal-anulacion-aerovale.component.css']
})
export class ModalAnulacionAerovaleComponent implements OnInit {

  @Input() detalle: AerovaleDetalle;
  @Input() imagenAerovaleAnulado: File;
  @Input() reemplaza: boolean;
  @Input() aerovale: AerovaleDetalle;

  anularForm: FormGroup;
  motivos: Observacion[] = [];
  anulando: boolean = false;
  cargandoObservaciones: boolean = false;
  errorObservaciones: boolean = false;

  prefijo: any;
  numeroAerovale: any;

  constructor(public modal: NgbActiveModal,
    private fb: FormBuilder,
    private aerovaleService: AerovalesService,
    private messageService: MessageService,
    private modalAceptar: NgbModal,
    private usuarioService: UsuarioService,
    private stockService: StockService,
    private azureBlobUpload: AzureBlobUploadService) { }

  // hooks

  ngOnInit() {
    this.prefijo = this.detalle.prefijo != null ? this.detalle.prefijo : this.aerovale.prefijo;
    this.numeroAerovale = this.detalle.numeroAerovale != null ? this.detalle.numeroAerovale : this.aerovale.numeroAerovale;
    this.anularForm = this.fb.group({
      motivoFormControl: new FormControl(null, [Validators.required]),
      descripcionFormControl: new FormControl(null, [Validators.required])
    });
    this.llenarMotivos();
  }

  // form

  llenarMotivos() {
    this.cargandoObservaciones = true;
    this.aerovaleService.getMotivosAnulacion(1)
      .subscribe(result => {
        this.motivos = result;
        this.cargandoObservaciones = false
      },
        () => this.errorObservaciones = true);
  }

  armarUsuario() {
    const u = new Usuario();
    u.id = this.usuarioService.getIdUsuario();
    u.nombreCompleto = this.usuarioService.getNombresCompletosUsuario();
    u.userName = this.usuarioService.getUsername();
    u.dni = this.usuarioService.getDniUsuario();

    return u;
  }

  // llamada al service

  anularAerovale() {
    this.anulando = true;
    if (this.anularForm.valid) {
      this.detalle.comentarios = this.comentarios.value;
      this.detalle.observacionId = this.observacion.value;

      const usuario = this.armarUsuario();

      if (!this.reemplaza) {
        this.aerovaleService.anularAerovale(this.detalle.id, this.detalle.comentarios, this.detalle.observacionId, usuario)
          .subscribe(result => {
            this.showResponse(result)
          }, (err: ErrorModel) => {
            this.anulando = false;
            this.messageService.showErrorMessage(err.message + "\n"+ err.description);
          });
      } else {
        const aevReplace = this.mapFormToAerovaleAnulacionReemplazo();

        const carga: CargaArchivo = new CargaArchivo(this.imagenAerovaleAnulado.name);
        this.stockService.obtenerSas(TipoBlobStorage.firmaoperador, true)
          .subscribe((sas: Sas) => {
            const aborter = this.azureBlobUpload.uploadFileToBlobStorage(this.imagenAerovaleAnulado, sas.containerUri, sas.sas,
              (pro) => {
                carga.progress = pro;
              },
              (val: BlobUploadCommonResponse) => {
                if (val) {
                  carga.progress = 100;

                  aevReplace.aerovaleDetalle.firmaOperador = "";
                  aevReplace.aerovaleDetalle.firmaCliente = "";
                  aevReplace.aerovaleDetalle.pathFirmaOperador = this.imagenAerovaleAnulado.name;
                  aevReplace.aerovaleDetalle.pathFirmaCliente = this.imagenAerovaleAnulado.name;
                }
                this.aerovaleService.anularYReemplazarAerovale(this.aerovale.id, this.imagenAerovaleAnulado, aevReplace)
                  .subscribe(result => {
                    if (result) {
                      this.showResponse(result);
                    } else {
                      this.anulando = false;
                      this.messageService.showErrorMessage('El aerovale no fue anulado y reemplazado.');
                    }
                  }, (err: ErrorModel) => {
                    this.anulando = false;
                    this.messageService.showErrorMessage(err.message + "\n"+ err.description);
                  });
              });
            carga.setAborter(aborter);
          }, (err: ErrorModel) => {
            this.messageService.showErrorMessage("Error al obtener el SAS.\n" + err.description);
          });


      }
    }
  }

  private mapFormToAerovaleAnulacionReemplazo(): AerovaleAnulacionReemplazoDTO {

    const aevReplace = new AerovaleAnulacionReemplazoDTO();

    aevReplace.aerovaleDetalle = this.detalle;
    aevReplace.comentario = this.comentarios.value;
    aevReplace.observacion = this.observacion.value;
    aevReplace.usuarioDto = this.armarUsuario();

    return aevReplace;
  }

  showResponse(result) {
    const modalRef = this.modalAceptar.open(ModalOkComponent, { centered: true });
    
    if(result) {
      modalRef.componentInstance.mensaje = isEmptyValue(result.warnings) ? `El aerovale fue anulado correctamente` : result.warnings[0];
    } else modalRef.componentInstance.mensaje = `El aerovale no pudo ser anulado`
    if (result) {
      modalRef.result.then(() => {
        this.modal.close(true);
        this.anularForm.reset();
      });
    }
    this.anulando = false;
  }

  // getters

  get comentarios() {
    return this.anularForm.get('descripcionFormControl');
  }

  get observacion() {
    return this.anularForm.get('motivoFormControl');
  }

}
